import { render } from "./AppRadio.vue?vue&type=template&id=f55e047e&ts=true"
import script from "./AppRadio.vue?vue&type=script&lang=ts"
export * from "./AppRadio.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/1/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__